export default __webpack_public_path__ + "static/media/rachid.81b9b759.png";